export function getTotalSum(num: number): string | number {
  if (num % 1 !== 0 && num.toString().split('.')[1].length > 2) {
    return Number(num).toFixed(2);
  } else {
    return num;
  }
}
